import React from 'react';
import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';

import Header from '../components/Header';
import FormSection from '../components/FormSection';
import Hero from '../components/Hero';
import Footer from '../components/Footer';

function Home() {
  const { refVisita } = useParams();

  return (
    <Box sx={{ overflowX: 'hidden' }}>
      <Header />
      <FormSection refVisita={refVisita} />
      <Hero />
      <Footer />
    </Box>
  );
}

export default Home;